import { Box, GridLegacy } from '@mui/material';
import { Tag } from 'types/clientV2/tag';
import Chip from 'ui-component/extended/Chip';

const Tags = ({ tags }: { tags?: Tag[] }) => (
  <Box>
    <GridLegacy
      container
      spacing={1}
      justifyContent="flex-start"
      sx={{ overflow: 'hidden' }}
    >
      {(tags || [])
        .filter((tag) => tag.active)
        .map((tag) => (
          <GridLegacy item key={tag.id} xs="auto">
            <Chip
              label={tag.name}
              title={tag.name}
              chipcolor={tag.color}
              type="tag"
            />
          </GridLegacy>
        ))}
    </GridLegacy>
  </Box>
);

export default Tags;
